// extracted by mini-css-extract-plugin
module.exports = {"panel":"package-alert_panel__Gok0O","package-alert":"package-alert_package-alert__5T068"};